// общие страницы калькулятора

import * as React from 'react'
import {FC, useEffect, useState} from 'react'
import Form from 'antd/lib/form'
import {Col, Row} from 'antd/lib/grid'
import 'antd/lib/grid/style'
import Spin from 'antd/lib/spin'
import 'antd/lib/spin/style'
import useController from '../../hooks/use-controller'
import Step from '../../../../common/components/step'
import CargoParams from '../cargo-params'
import TransportParams from '../transport-params'
import ContactParams from '../contact-params'
import Header from '../../../../common/components/header'
import {COMPONENT_SIZE, HEADER_STEPS, HEADER_STEPS_INSURER} from '../../constants'
import GlobalOptionsInterface from '../../types/global-options'
import CheckWrapper from '../../../../common/components/check-wrapper'
import Check from '../check'
import './index.less'
import Result from 'antd/lib/result'
import 'antd/lib/result/style'
import CheckCost from '../../../../common/components/check-cost'
import ControlBlockModeSwitch from '../control-block-mode-switch'
import useModals from '../../hooks/use-modals'
import getInfo from '../../helpers/get-info'
import {CargoTypes} from '../../types/models/cargo-types'
import {ProgramInfo} from '../../types/models/program-info'
import Button from 'antd/lib/button'
import 'antd/lib/button/style'
import SelectOutlined from '@ant-design/icons/lib/icons/SelectOutlined'
import IDS from '../../constants/ids'
import TEST_VALUES from "../../constants/test-values";

interface CalculatorPropsInterface {
    globalOptions: GlobalOptionsInterface
}

type InfoInterface = {
    cargoTypes: CargoTypes
    programInfo: ProgramInfo
}

// храним полученные типы грузов и инфу,
// чтобы не загружать повторно
let savedInfo: InfoInterface = null

const Calculator: FC<CalculatorPropsInterface> = ({globalOptions}) => {
    const {form, currentStep, cost, prevStep, recalculate, handleNextClick} = useController({
            globalOptions,
        }),
        nextDisabled = cost.requestStatus === 'started',
        [info, setInfo] = useState<InfoInterface>(null)

    useModals(cost)

    useEffect(() => {
        // проверяем сохранённые вне компонента программы,
        // чтобы не загружать их повторно
        if (savedInfo === null) {
            getInfo().then(res => {
                savedInfo = res
                setInfo(res)
            })
        } else {
            setInfo(savedInfo)
        }
    }, [])

    // показываем спиннер, пока не загрузились данные по типам грузов и настройкам
    if (info === null) {
        return (
            <Row justify={'center'}>
                <Spin size='large' />
            </Row>
        )
    }

    return (
        <Form
            className={'e-calc'}
            layout={'vertical'}
            form={form}
            name={'main'}
            size={COMPONENT_SIZE}
            initialValues={{
                insurer: {
                    type: 'individual'
                }
            }}
        >
            <Row gutter={64}>
                <Col sm={24}>
                    <div className='e-smart-padding-left'>
                        <Header
                            currentStep={currentStep}
                            calcSteps={
                                globalOptions.calcMode &&
                                globalOptions.calcMode.match(/^(agent|underwriter|precheck)$/)
                                    ? HEADER_STEPS_INSURER
                                    : HEADER_STEPS
                            }
                        />
                    </div>
                </Col>
                <Col xs={24} md={14}>
                    <Step hidden={currentStep !== 0}>
                        <CargoParams
                            form={form}
                            cargoTypes={info.cargoTypes}
                            programInfo={info.programInfo}
                            onValueChange={recalculate}
                        />
                    </Step>
                    <Step hidden={currentStep !== 1}>
                        <TransportParams
                            form={form}
                            programInfo={info.programInfo}
                            onValueChange={recalculate} // <---- try to CargoParams
                        />
                    </Step>
                    <Step hidden={currentStep !== 2}>
                        <ContactParams form={form} globalOptions={globalOptions} />
                    </Step>
                    <Step hidden={currentStep !== 3}>
                        <div className='e-smart-padding-left'>
                            <Result
                                status='success'
                                title={'Заявка ' + ' успешно отправлена!'}
                                subTitle={
                                    globalOptions.calcMode &&
                                    globalOptions.calcMode.match(
                                        /^(agent|underwriter|precheck|superuser)$/
                                    ) ? (
                                        <Button
                                            className={'e-control-block__button'}
                                            type={'primary'}
                                            icon={<SelectOutlined />}
                                            size={COMPONENT_SIZE}
                                            onClick={() => {
                                                window
                                                    .open(
                                                        `${window?.origin}/${
                                                            window?.origin ===
                                                            'https://agent.euro-ins.ru'
                                                                ? ''
                                                                : 'admin/'
                                                        }cargo/policy/full_calc/${form.getFieldValue(
                                                            IDS.CALCULATION_ID
                                                        )}`,
                                                        '_blank'
                                                    )
                                                    .focus()
                                            }}
                                        >
                                            Перейти к оформлению полиса
                                        </Button>
                                    ) : (
                                        'Скоро с вами свяжутся наши менеджеры'
                                    )
                                }
                            />
                        </div>
                    </Step>
                </Col>
                <Col xs={24} md={8}>
                    <CheckWrapper rootNodeId={globalOptions.rootNodeId} currentStep={currentStep}>
                        <Check
                            cargoTypes={info.cargoTypes}
                            percent={
                                cost.data === null
                                    ? 0
                                    : cost.data.detail.program *
                                      cost.data.detail.distance *
                                      cost.data.detail.franchise *
                                      cost.data.detail.packaging *
                                      cost.data.detail.shipping *
                                      cost.data.detail.storage *
                                      cost.data.detail.transport
                            }
                        />
                        <CheckCost
                            currentStep={currentStep}
                            cost={cost.data === null ? 0 : cost.data.total}
                            defaultCost={'от 500'}
                            loadingCost={cost.requestStatus === 'started'}
                            bonusesSystemIsOn={false}
                            rootNodeId={globalOptions.rootNodeId}
                            onPrevStepClick={prevStep}
                        />
                    </CheckWrapper>
                </Col>
            </Row>
            <Row gutter={64}>
                <Col xs={24} sm={24} md={14}>
                    <ControlBlockModeSwitch
                        currentStep={currentStep}
                        onNextClick={handleNextClick}
                        onPrevClick={prevStep}
                        nextDisabled={nextDisabled}
                    />
                </Col>
            </Row>

            {ENV_IS_DEV ? (
                <>
                    <button
                        onClick={e => {
                            form.setFieldsValue(TEST_VALUES)
                        }}
                    >
                        Заполнить форму
                    </button>
                    <button
                        onClick={e => {
                            e.preventDefault()
                            // e.stopPropagation()
                            console.log(form.getFieldsValue())
                            console.log(globalOptions)
                        }}
                    >
                        Данные формы
                    </button>
                </>
            ) : null}
        </Form>
    )
}

export default Calculator
